import { LensCuttingMachineIntegrationStatus } from "../enums/LensCuttingMachineIntegrationStatus";

export const lensCuttingMachineIntegrationStatusMapping = {
  [LensCuttingMachineIntegrationStatus.Error]: 'Erro',
  [LensCuttingMachineIntegrationStatus.PendingGeneration]: 'Pendente de Geração',
  [LensCuttingMachineIntegrationStatus.PendingIntegration]: 'Pendente de Integração',
  [LensCuttingMachineIntegrationStatus.Integrating]: 'Integração em Andamento',
  [LensCuttingMachineIntegrationStatus.Integrated]: 'Integrado',
}